import React from 'react'
import { Col, Row } from 'react-bootstrap'
import Loader from 'components/ui/loader/Loader'

import { COURSE, TDataCourse, QueryCourseAllArgs } from 'graphqlAPI'
import { Cards } from '../Cards'

import { useTranslationRankmi } from 'helpers/translations.helper'
import { useQuery } from '@apollo/client'
import Progress from 'components/monitoring/components/Progress'
import styles from './CourseProgress.module.scss'
import { prefix } from '../constants'
import { getProgressPercentage } from 'components/monitoring/utils'

interface CourseProgressProps {
  courseId: string
  areaId?: string | number
}

export const CourseProgress: React.FC<CourseProgressProps> = ({
  courseId,
  areaId,
}) => {
  const { data, loading } = useQuery<TDataCourse, QueryCourseAllArgs>(COURSE, {
    variables: { id: courseId, areaId: areaId?.toString() },
  })

  const course = data?.course

  const progress = React.useMemo(() => {
    return {
      finish: 0,
      inProgress: 0,
      pending: 0,
      ...course?.progress,
    }
  }, [course?.progress])

  const { finish, inProgress, pending } = getProgressPercentage([progress])

  const tRelative = useTranslationRankmi({ prefix: prefix })

  if (loading) {
    return (
      <Col>
        <div className="d-flex justify-content-center">
          <Loader color />
        </div>
      </Col>
    )
  }

  if (!course) return null

  const { participantsCount } = course

  return (
    <>
      <Col md={12} lg={5}>
        <Row className="align-content-between h-100 py-3">
          <Col xs={12}>
            <div className={styles.titleGlobal}>{tRelative('progress')}</div>
          </Col>
          <Col xs={12}>
            <div className="align-items-center d-flex">
              <Progress
                finish={finish}
                inProgress={inProgress}
                pending={pending}
              />
            </div>
          </Col>
        </Row>
      </Col>
      <Col lg={1} />
      <Col md={12} lg={6}>
        <Row className="d-flex justify-content-between mt-3">
          <Col xs={12} sm={6} md={3}>
            <Cards
              className="my-2"
              title={tRelative('cards.participants')}
              count={participantsCount}
            />
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Cards
              className="my-2"
              title={tRelative('cards.finished')}
              count={progress.finish}
              total={participantsCount}
              classes={{ card: styles.finish, total: styles.total }}
            />
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Cards
              className="my-2"
              title={tRelative('cards.inProgress')}
              count={progress.inProgress}
              total={participantsCount}
              classes={{ card: styles.inProcess, total: styles.total }}
            />
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Cards
              className="my-2"
              title={tRelative('cards.pending')}
              count={progress.pending}
              total={participantsCount}
              classes={{ card: styles.waiting, total: styles.total }}
            />
          </Col>
        </Row>
      </Col>
    </>
  )
}
